import React from 'react';

import { Divider } from 'redpoints-front-components/index';
import { LinkDataSocialMediaForm } from 'redpoints-front-common/components';

import { translate } from '../../../helpers/languageHelper';

const IncidentDetailsLinkDataSocialMedia = ({
  editable = true,
  forceValidation,
  socialMediaLinkData,
  socialMediaLinkDataChange,
  socialMediaLinkDataValidate,
  socialMediaLinkMetadata,
}) => (
  <>
    <Divider />
    <h3>{translate('reporting.incidentDetails.socialMedia.title')}</h3>
    <LinkDataSocialMediaForm
      editable={editable}
      forceValidation={forceValidation}
      onChange={socialMediaLinkDataChange}
      onValidate={socialMediaLinkDataValidate}
      shouldIgnoreMandatoryValidation
      socialMediaLinkData={socialMediaLinkData}
      socialMediaLinkMetadata={socialMediaLinkMetadata}
    />
  </>
);

export default IncidentDetailsLinkDataSocialMedia;
